import React from 'react';

const StatsDashboard = ({ workouts, activeUnit }) => {
  // 1. Total Workouts
  const totalWorkouts = workouts ? workouts.length : 0;

  // 2. Total Lifted Volume
  const totalVolume = workouts
    ? workouts.reduce((sum, w) => sum + (Number(w.load) || 0) * (Number(w.reps) || 0), 0)
    : 0;

  const formatVolume = (vol) => {
    if (vol >= 1000000) return `${(vol / 1000000).toFixed(1)}M`;
    if (vol >= 1000) return `${(vol / 1000).toFixed(1)}k`;
    return vol;
  };

  // 3. Peak Load
  const peakLoad = workouts && workouts.length > 0
    ? Math.max(...workouts.map(w => Number(w.load) || 0))
    : 0;

  // 4. Top Category
  const categoryCounts = {};
  if (workouts) {
    workouts.forEach(w => {
      const cat = w.category || 'Strength';
      categoryCounts[cat] = (categoryCounts[cat] || 0) + 1;
    });
  }

  let topCategory = 'N/A';
  let maxCount = 0;
  Object.entries(categoryCounts).forEach(([cat, count]) => {
    if (count > maxCount) {
      maxCount = count;
      topCategory = cat;
    }
  });

  return (
    <div className="dashboard-stats">
      {/* Total Workouts */}
      <div className="stat-card">
        <div className="stat-icon">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2zm0 4H7v-2h10v2zm0-8H7V7h10v2z"/>
          </svg>
        </div>
        <div className="stat-details">
          <h3>{totalWorkouts}</h3>
          <p>Total Exercises</p>
        </div>
      </div>

      {/* Total Lifted Volume */}
      <div className="stat-card">
        <div className="stat-icon">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H7c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.04-.42 1.99-1.07 2.75z"/>
          </svg>
        </div>
        <div className="stat-details">
          <h3>{formatVolume(totalVolume)} <span style={{ fontSize: '1rem', fontWeight: 500 }}>{activeUnit}</span></h3>
          <p>Total Volume</p>
        </div>
      </div>

      {/* Peak Load */}
      <div className="stat-card">
        <div className="stat-icon" style={{ color: 'var(--accent-strength)' }}>
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor" d="M20.5 11H19V8c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v3H9V8c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v3H3.5c-.83 0-1.5.67-1.5 1.5S2.67 14 3.5 14H5v3c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-3h6v3c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-3h1.5c.83 0 1.5-.67 1.5-1.5S21.33 11 20.5 11z"/>
          </svg>
        </div>
        <div className="stat-details">
          <h3>{peakLoad} <span style={{ fontSize: '1rem', fontWeight: 500 }}>{activeUnit}</span></h3>
          <p>Peak Load (PR)</p>
        </div>
      </div>

      {/* Top Category */}
      <div className="stat-card">
        <div className="stat-icon" style={{ color: 'var(--accent-endurance)' }}>
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
          </svg>
        </div>
        <div className="stat-details">
          <h3 style={{ textTransform: 'capitalize', fontSize: topCategory.length > 8 ? '1.4rem' : '1.8rem' }}>{topCategory}</h3>
          <p>Primary Focus</p>
        </div>
      </div>
    </div>
  );
};

export default StatsDashboard;
